import React from 'react';
import { Box, Dialog } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { CustomButton } from '../../../../v2/MUI_custom_component';
import IllustrationWrapper from '../../../Illustrration/IllustrationWrapper';
import DisclaimerSvg from '../../../Illustrration/components/DisclaimerSvg';

const ReusableOCRFailureModal = ({ 
    open, 
    onClose, 
    onTryAgain, 
    onEnterManually, 
    errorMessage,
    title = "Document Invalid",
    tryAgainText = "Try Again",
    enterManuallyText = "Enter Manually",
    maxWidth = "500px",
    showIcon = true,
    icon = WarningIcon,
    iconColor = "#ff9800",
    iconSize = 80
}) => {
    const IconComponent = icon;
    
    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: 2,
            textAlign: "center",
            width: 400,
            p: 2,
            m: 0,
            gap: 4,
          },
        }}>
        <Box sx={{ textAlign: "center" }}>
          {showIcon && IconComponent && (
            <IllustrationWrapper
              illustration={<DisclaimerSvg />}
              title={title}
              subtitle={errorMessage && errorMessage}
            />
          )}
        </Box>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <CustomButton
            variant="outlined"
            color="primary"
            onClick={onTryAgain}
            label={tryAgainText}
            sx={{ width: "100%" }}
          />
          <CustomButton
            variant="filled"
            color="primary"
            onClick={onEnterManually}
            label={enterManuallyText}
            sx={{ width: "100%" }}
          />
        </Box>
      </Dialog>
    );
};

export default ReusableOCRFailureModal;